var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowLong = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 90 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m81.873 12.672 6.19 10.183c1.78-2.167 1.792-4.333.988-6.04-2.39-5.069-4.853-10.134-7.807-14.85-1.694-2.7-4.517-2.186-6.176.798-2.767 4.98-5.29 10.082-7.91 15.135-.152.296-.398.655-.349.917.158.837.435 1.644.666 2.462.713-.271 1.695-.342 2.094-.85 1.347-1.714 2.492-3.582 3.71-5.393.638-.95 1.268-1.904 2.73-2.79.01 1.668.093 3.336.02 5.008-1.487 34.01-24.596 64.097-57.764 75.09-4.24 1.406-8.61 2.299-12.914 3.455-1.5.403-2.986.884-4.478 1.329l-.116 1.09c.874.373 1.737 1.107 2.622 1.055 3.071-.18 6.176-.406 9.22-1.016 30.838-6.184 57.023-31.411 65.162-63.047 1.552-6.034 2.014-12.26 2.938-18.401.19-1.263.197-2.539.289-3.81l.885-.325Z",
  fill: "currentColor"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLong);
export default ForwardRef;